<ion-content no-bounce>
  <div class="login-background"></div>
  <ion-grid no-padding>
    <ion-row justify-content-center no-padding style="justify-content: center">
      <ion-col size-sm="8" size-lg="6" size-xl="4" align-self-center no-padding>
        <div class="login-container-wrapper">
          <form novalidate (ngSubmit)="onSubmit()" [formGroup]="form">
            <ion-list>
              <ion-item-divider>
                <ion-label> School details </ion-label>
              </ion-item-divider>
              <ion-item lines="inset">
                <ion-label color="medium" position="floating">School name</ion-label>
                <ion-input
                  data-testid="company-input"
                  type="text"
                  formControlName="company"
                  autocomplete="organization"
                  placeholder=""
                ></ion-input>
              </ion-item>
              @if (submitted && form.get('company').hasError('required')) {
                <ion-text data-testid="company-required-error" color="danger" class="error-message">
                  <span padding>Please enter the school name</span>
                </ion-text>
              }
              <ion-item lines="inset">
                <ion-label color="medium" position="floating">School Address line 1</ion-label>
                <ion-input
                  data-testid="address1-input"
                  type="text"
                  formControlName="address1"
                  autocomplete="address-line1"
                  placeholder=""
                ></ion-input>
              </ion-item>
              @if (submitted && form.get('address1').hasError('required')) {
                <ion-text data-testid="address1-required-error" color="danger" class="error-message">
                  <span padding>Please enter the first line of the schools address</span>
                </ion-text>
              }
              <ion-item lines="inset">
                <ion-label color="medium" position="floating">School Address line 2</ion-label>
                <ion-input
                  data-testid="address2-input"
                  type="text"
                  formControlName="address2"
                  autocomplete="address-line2"
                  placeholder=""
                ></ion-input>
              </ion-item>
              <ion-item lines="inset">
                <ion-label color="medium" position="floating">School Address line 3</ion-label>
                <ion-input
                  data-testid="address3-input"
                  type="text"
                  formControlName="address3"
                  autocomplete="address-line3"
                  placeholder=""
                ></ion-input>
              </ion-item>
              <ion-item lines="inset">
                <ion-label color="medium" position="floating">School Town or City</ion-label>
                <ion-input
                  data-testid="townCity-input"
                  type="text"
                  formControlName="townCity"
                  autocomplete="address-level2"
                  placeholder=""
                ></ion-input>
              </ion-item>
              @if (submitted && form.get('townCity').hasError('required')) {
                <ion-text data-testid="townCity-required-error" color="danger" class="error-message">
                  <span padding>Please enter the school town or city</span>
                </ion-text>
              }
              <ion-item lines="inset">
                <ion-label color="medium" position="floating">School Postcode</ion-label>
                <ion-input
                  data-testid="postcode-input"
                  type="text"
                  formControlName="postcode"
                  autocomplete="postal-code"
                  placeholder=""
                ></ion-input>
              </ion-item>
              @if (submitted && form.get('postcode').hasError('required')) {
                <ion-text data-testid="postcode-required-error" color="danger" class="error-message">
                  <span padding>Please enter the school postcode</span>
                </ion-text>
              }
              @if (submitted && form.get('postcode').hasError('pattern')) {
                <ion-text data-testid="postcode-pattern-error" color="danger" class="error-message">
                  <span padding>Please enter a valid school postcode</span>
                </ion-text>
              }
              <ion-item-divider class="ion-margin-top">
                <ion-label> Your details </ion-label>
              </ion-item-divider>
              <ion-item lines="inset">
                <ion-label color="medium" position="floating">Job Title</ion-label>
                <ion-input
                  data-testid="jobTitle-input"
                  type="text"
                  formControlName="jobTitle"
                  placeholder=""
                ></ion-input>
              </ion-item>
              @if (submitted && form.get('jobTitle').hasError('required')) {
                <ion-text data-testid="jobTitle-required-error" color="danger" class="error-message">
                  <span padding>Please enter your job title</span>
                </ion-text>
              }
              <ion-item lines="inset">
                <ion-label color="medium" position="floating">Mobile number</ion-label>
                <ion-input
                  data-testid="phone-input"
                  type="tel"
                  formControlName="phone"
                  autocomplete="tel"
                  placeholder=""
                ></ion-input>
              </ion-item>
              @if (submitted && form.get('phone').hasError('required')) {
                <ion-text data-testid="phone-required-error" color="danger" class="error-message">
                  <span padding>Please enter your phone number</span>
                </ion-text>
              }
              @if (submitted && form.get('phone').hasError('pattern')) {
                <ion-text data-testid="phone-pattern-error" color="danger" class="error-message">
                  <span padding>Please enter a valid phone number</span>
                </ion-text>
              }
              <ion-item lines="inset">
                <ion-label color="medium" position="floating">How did you hear about us?</ion-label>
                <ion-select data-testid="howHeard-input" formControlName="howHeard">
                  <ion-select-option>PE Pro website</ion-select-option>
                  <ion-select-option>Google</ion-select-option>
                  <ion-select-option>Facebook</ion-select-option>
                  <ion-select-option>LinkedIn</ion-select-option>
                  <ion-select-option>Twitter</ion-select-option>
                  <ion-select-option>Word of mouth</ion-select-option>
                  <ion-select-option>Other</ion-select-option>
                </ion-select>
              </ion-item>
              @if (submitted && form.get('howHeard').hasError('required')) {
                <ion-text data-testid="howHeard-required-error" color="danger" class="error-message">
                  <span padding>Please enter how you heard about us</span>
                </ion-text>
              }
              @if (form.get('howHeard').value === 'Other') {
                <ion-item lines="inset">
                  <ion-label color="medium" position="floating">
                    Other (Please specify where you heard about us)
                  </ion-label>
                  <ion-input
                    data-testid="howHeardOther-input"
                    type="text"
                    formControlName="howHeardOther"
                    placeholder=""
                  ></ion-input>
                </ion-item>
              }
              @if (
                submitted && form.get('howHeard').value === 'Other' && form.get('howHeardOther').hasError('required')
              ) {
                <ion-text data-testid="howHeardOther-required-error" color="danger" class="error-message">
                  <span padding>Please enter how you heard about us</span>
                </ion-text>
              }
            </ion-list>
            <ion-button routerLink="/login" color="danger" expand="block" class="ion-margin-top" [disabled]="isSubmitting">
              Cancel
            </ion-button>
            <ion-button
              data-testid="next-button-step2"
              type="submit"
              color="primary"
              expand="block"
              class="ion-margin-top"
              [disabled]="isSubmitting"
            >
              @if (isSubmitting) {
                <ion-spinner name="crescent" slot="start"></ion-spinner>
              }
              {{ isSubmitting ? 'Creating account...' : 'Submit' }}
            </ion-button>
          </form>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
